import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PersentageDonutChartWithBottomLegend
    from '../../ChartsImpl/DetailsPageCharts/PersentageDonutChartWithBottomLegend';
import ProcessChartWithBottomLegend from '../../ChartsImpl/DetailsPageCharts/ProcessChartWithBottomLegend';
import MUIDataTable from 'mui-datatables';
import CircularProgress from "@mui/material/CircularProgress";
import toast, { Toaster } from "react-hot-toast";
import axios from 'axios';

const ServiceTimeExceptionDetails = (props) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');

    const [chartValue, setChartValue] = useState(0);

    const [tokenData, settokenData] = useState([]);
    const [chartData, setchartData] = useState([]);

    const [categoryList, setcategoryList] = useState([]);
    const [percentageList, setpercentageList] = useState([]);

    const [tokenTableData, setTokenTableData] = useState([]);
    const [categoiesForRender, setCategoiesForRender] = useState([])

    const [update, setUpdate] = useState('1s')

    const [isLoading, setLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [tokenCounts, setTokenCounts] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        let postsArray = JSON.parse(JSON.stringify(tokenData));
        let categoryData = [];
        postsArray.map((item, index) => {

            item.index = (
                <div>
                    {index + 1}
                </div>
            )

            if (item.status === 0) {
                item.status = "Waiting"
            } else if (item.status === 1) {
                item.status = "Serving"
            } else if (item.status === 2) {
                item.status = "No show"
            } else if (item.status === 3) {
                item.status = "Local waiting"
            } else if (item.status === 4) {
                item.status = "Served"
            }

            categoryData.push(item);
        });
        setTokenTableData(categoryData);
        setCategoiesForRender(categoryData);
    }, [tokenData]);

    useEffect(() => {
        if (props.showServiceTimeExDetails === false) return;
        if (props.serviceExceptionInc > 0 || props.messageInc1011 !== '' || props.messageInc1001 !== '' || props.messageInc1000 !== '') {
            getServiceExceptionData();
        }
    }, [props.serviceExceptionInc, props.messageInc1011, props.messageInc1000, props.messageInc1001]);

    useEffect(() => {
        setChartValue(chartValue + 1);
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            if (tokenData !== null && tokenData.length > 0) {
                for (let index = 0; index < tokenData.length; index++) {
                    const element = tokenData[index];
                    if (element.status === 1) {
                        element.timeSpendingToSec = element.timeSpendingToSec + 5;

                        let hours = Math.floor(element.timeSpendingToSec / 3600);
                        let minutes = Math.floor((element.timeSpendingToSec - (hours * 3600)) / 60);
                        let seconds = element.timeSpendingToSec - (hours * 3600) - (minutes * 60);

                        if (hours < 10) { hours = "0" + hours; }
                        if (minutes < 10) { minutes = "0" + minutes; }
                        if (seconds < 10) { seconds = "0" + seconds; }

                        element.timeSpending = `${hours}:${minutes}:${seconds}`;
                    }
                }

                console.log("token data: ", tokenData);

                settokenData(tokenData);
                setUpdate(new Date().toString());
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [tokenData]);

    const getServiceExceptionData = () => {
        console.log('getServiceExceptionData function start');
        setLoading(true)
        axios({
            method: 'GET',
            url: `${baseUrl}/real-time/get-category-ticket-service-details/inner-data/branch/${props.selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getWaitingExceptionData success');
            let data = res.data.data;
            console.log("service ex data: ", data);
            loopChartData(data.chartData);
            setLoading(false)
            if (data.tokenData !== []) {
                settokenData(data.tokenData);
                setCount(data.tokenData.length);
                const uniqueArray = [...new Set(data.tokenData.map(item => item.ticketNo))];
                setTokenCounts(uniqueArray.length);
            }

            if (data.chartData !== []) {
                setchartData(data.chartData);
            }
            setChartValue(chartValue + 1);

        }).catch((error) => {
            console.log('getTicketIssuedDetails error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const loopChartData = (data) => {
        const categories = [];
        const percentages = [];

        data.forEach(element => {
            categories.push(element.category);
            percentages.push(element.percentage);
        });

        setcategoryList(categories);
        setpercentageList(percentages);
    }

    const closeModal = () => {
        props.setShowServiceTimeExDetails(false)

        settokenData([]);
        setchartData([]);
    }

    const options = {
        tableBodyHeight: '50vh',
        filter: false,
        responsive: 'vertical',
        serverSide: false,
        count: count,
        download: false,
        viewColumns: false,
        jumpToPage: true,
        selectableRows: 'none',
        print: false,
        rowsPerPage: rowsPerPage,
        onChangeRowsPerPage: (n) => {
            setRowsPerPage(n)
        },
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        }
    };

    const columns = [
        {
            label: 'Token No',
            name: 'ticketNo',
            options: {
                sort: true,
                filter: false
            }
        },
        {
            label: "Category",
            name: 'categoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Language',
            name: 'language',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'Operator',
            name: 'operator',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Called time',
            name: 'calledTime',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'Served time',
            name: 'id',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (tokenData === undefined) return;
                    let item = tokenData.find(item => item.id === value);
                    return (<>
                        {item.status === 1 ? (<div>{item.timeSpending}</div>)
                            : item.status === 2 ? 'No Show'
                                : item.status === 3 ? 'Local Waiting'
                                    : item.status === 4 ? (<div>{item.timeSpending}</div>)
                                        : 'Pending'}
                    </>);
                }
            },
        },
        {
            label: 'KPI',
            name: 'kpi',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Status',
            name: 'id',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (tokenData === undefined) return;
                    let item = tokenData.find(item => item.id === value);
                    return (<>
                        {item.status === 1 ? (<span className="badge badge-info ml-1 mb-2">{item.timeSpending}</span>)
                            : item.status === 2 ? (<span className="badge badge-warning ml-1 mb-2">no show</span>)
                                : item.status === 3 ? (<span className="badge badge-warning ml-1 mb-2">waiting</span>)
                                    : item.status === 4 ? (<span className="badge badge-success ml-1 mb-2">served</span>)
                                        : 'Pending'}
                    </>);
                }
            },
        }
    ];

    const columns_1 = [
        {
            label: "Branch",
            name: 'branchName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Token No',
            name: 'ticketNo',
            options: {
                sort: true,
                filter: false
            }
        },
        {
            label: "Category",
            name: 'categoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Language',
            name: 'language',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'Operator',
            name: 'operator',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Called time',
            name: 'calledTime',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'Served time',
            name: 'id',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (tokenData === undefined) return;
                    let item = tokenData.find(item => item.id === value);
                    return (<>
                        {item.status === 1 ? (<div>{item.timeSpending}</div>)
                            : item.status === 2 ? 'No Show'
                                : item.status === 3 ? 'Local Waiting'
                                    : item.status === 4 ? (<div>{item.timeSpending}</div>)
                                        : (<span className="badge badge-default ml-1 mb-2">pending</span>)}
                    </>);
                }
            },
        },
        {
            label: 'KPI',
            name: 'kpi',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Status',
            name: 'id',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (tokenData === undefined) return;
                    let item = tokenData.find(item => item.id === value);
                    return (<>
                        {item.status === 1 ? (<span className="badge badge-info ml-1 mb-2">{item.timeSpending}</span>)
                            : item.status === 2 ? (<span className="badge badge-warning ml-1 mb-2">no show</span>)
                                : item.status === 3 ? (<span className="badge badge-warning ml-1 mb-2">waiting</span>)
                                    : item.status === 4 ? (<span className="badge badge-success ml-1 mb-2">served</span>)
                                        : 'Pending'}
                    </>);
                }
            },
        }
    ];

    return (
        <>
            {props.showServiceTimeExDetails ?
                <div id="megamenu" className={`megamenu particles_js details-page open `}>
                    <span
                        onClick={() => {
                            props.setSticky(true)
                            props.setShowServiceTimeExDetails(false);
                            closeModal();
                        }}
                        className="megamenu_toggle btn btn-danger"><i className="icon-close"></i></span>
                    <div className="container">
                        <div className="row clearfix">
                            <div className="col-12">
                                <div className="card">
                                    <div className="body">
                                        <div style={{ textAlign: 'center' }}>
                                            <h4>Service Time Exceptions</h4>
                                            <small>{props.date}</small>
                                        </div>
                                        <br></br>
                                        <div className="row clearfix">
                                            <div className="col-4">

                                                {
                                                    chartData.length !== 0 && chartValue > 0 ? <PersentageDonutChartWithBottomLegend
                                                        lable={categoryList} percentage={percentageList} chartValue={chartValue} />
                                                        :
                                                        <PersentageDonutChartWithBottomLegend
                                                            lable={[]} percentage={[]} chartValue={0} />
                                                }

                                                <div className='mt-4'>
                                                    <div style={{ overflowY: 'scroll', height: '200px' }}>
                                                        <table className="table table-hover table-custom">
                                                            <tbody>
                                                                {chartData.map((data, i) =>
                                                                    <tr key={i}>
                                                                        <td>{data.category}</td>
                                                                        <td>{data.serviceExceptionsCount}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-8">
                                                <div className="muidatatablecontainer">
                                                    {props.selectedBranchLevel === 4 ? (
                                                        <MUIDataTable
                                                            title={<>
                                                                <>
                                                                    <span className="badge badge-success ml-1 mb-2">{tokenCounts}</span> Tickets Count.
                                                                    <span className="badge badge-info ml-4 mb-2">{count}</span> Transactions Count.
                                                                </>
                                                                {isLoading &&
                                                                    <>&nbsp;&nbsp;&nbsp;<CircularProgress color="primary"
                                                                        size={20} /></>}
                                                            </>
                                                            }
                                                            data={tokenData}
                                                            columns={columns}
                                                            options={options}
                                                        />
                                                    ) : (
                                                        <MUIDataTable
                                                            title={<>
                                                                <>
                                                                    <span className="badge badge-success ml-1 mb-2">{tokenCounts}</span> Tickets Count.
                                                                    <span className="badge badge-info ml-4 mb-2">{count}</span> Transactions Count.
                                                                </>
                                                                {isLoading &&
                                                                    <>&nbsp;&nbsp;&nbsp;<CircularProgress color="primary"
                                                                        size={20} /></>}
                                                            </>
                                                            }
                                                            data={tokenData}
                                                            columns={columns_1}
                                                            options={options}
                                                        />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div id="particles-js"></div>
                </div>
                : null}
        </>
    );
}


export default ServiceTimeExceptionDetails;